export default "__VITE_ASSET__C0s4SOCQ__"